import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "social-media-popup"
};
const _hoisted_2 = {
  class: "popup-main"
};
const _hoisted_3 = {
  class: "popup-header"
};
const _hoisted_4 = {
  class: "popup-title"
};
const _hoisted_5 = {
  class: "popup-content"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "follow-text"
}, [/*#__PURE__*/_createTextVNode("Follow and like us on "), /*#__PURE__*/_createElementVNode("span", {
  class: "highlight"
}, "Official Facebook"), /*#__PURE__*/_createTextVNode(" and "), /*#__PURE__*/_createElementVNode("span", {
  class: "highlight"
}, "Telegram"), /*#__PURE__*/_createTextVNode(" pages and get updates for our latest activities and bonuses!")], -1);
const _hoisted_7 = {
  class: "social-media-list flex"
};
const _hoisted_8 = {
  class: "social-media-item"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "social-media-name"
}, "Facebook", -1);
const _hoisted_10 = {
  class: "social-media-item"
};
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "social-media-name"
}, "Telegram", -1);
import { ref } from 'vue';
import { useHelpTool } from '@/hooks';
export default {
  __name: 'SocialMedia',
  emits: ['onClose'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const {
      doFollow
    } = useHelpTool();
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_popup = _resolveComponent("van-popup");
      const _directive_audio = _resolveDirective("audio");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_popup, {
        show: true,
        "close-on-click-overlay": false,
        "lock-scroll": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('socialMedia.followRewards').toUpperCase()), 1), _withDirectives(_createVNode(_component_van_image, {
          class: "close-icon",
          src: require('@/assets/img/common/popup-close.png'),
          onClick: _cache[0] || (_cache[0] = $event => emit('onClose'))
        }, null, 8, ["src"]), [[_directive_audio, void 0, "close"]])]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_van_image, {
          class: "social-media-img",
          src: require('@/assets/img/social-media/facebook.png')
        }, null, 8, ["src"]), _withDirectives((_openBlock(), _createBlock(_component_van_button, {
          class: "follow-btn",
          onClick: _cache[1] || (_cache[1] = $event => _unref(doFollow)({
            type: 'facebook'
          }))
        }, {
          default: _withCtx(() => [_createTextVNode("+" + _toDisplayString(_ctx.$t('common.follow')), 1)]),
          _: 1
        })), [[_directive_audio]])]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createVNode(_component_van_image, {
          class: "social-media-img",
          src: require('@/assets/img/social-media/telegram.png')
        }, null, 8, ["src"]), _withDirectives((_openBlock(), _createBlock(_component_van_button, {
          class: "follow-btn",
          onClick: _cache[2] || (_cache[2] = $event => _unref(doFollow)({
            type: 'telegram'
          }))
        }, {
          default: _withCtx(() => [_createTextVNode("+" + _toDisplayString(_ctx.$t('common.follow')), 1)]),
          _: 1
        })), [[_directive_audio]])])])]), _createVNode(_component_van_image, {
          class: "popup-left-img",
          src: require('@/assets/img/social-media/left-bg.png')
        }, null, 8, ["src"]), _createVNode(_component_van_image, {
          class: "popup-right-img",
          src: require('@/assets/img/social-media/right-bg.png')
        }, null, 8, ["src"])])]),
        _: 1
      })]);
    };
  }
};